export default __webpack_public_path__ + "static/media/about-us-banner-ms.980585c3.webp";